if (module.hot) {
    module.hot.accept();
}

function makeMarquee() {
    const title = 'I just learned how to do marquee in CSS';
    const marqueeText = new Array(50).fill(title).join(' &mdash; ');

    const marquee = document.querySelector('.marquee span');
    marquee.innerHTML = marqueeText;
    // console.log(marqueeText)
}
makeMarquee();

function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const circles = document.querySelectorAll('.circle');

circles.forEach((circle, index) => {
    circle.animate(
        [
            //   keyframes
            { transform: 'scale(1)' },
            { transform: 'scale(1.2)' },
            { transform: 'scale(1)' }
        ],
        {
            delay: 300 * index,
            duration: 3000,
            iterations: Infinity
        }
    );
});

const squiggles = document.querySelectorAll('.squiggle');

squiggles.forEach((squiggle, index) => {
    const randomNumber = random(0, 45);

    squiggle.animate(
        [
            //   keyframes
            { transform: 'rotate(0deg)' },
            //    {transform: 'rotate( ${randomNumber} deg)'},
            { transform: 'rotate(' + randomNumber + 'deg)' },
            { transform: 'rotate(0deg)' }
        ],
        {
            delay: 300 * index,
            duration: 5000,
            iterations: Infinity
        }
    );
});

// detect when section is on viewport, add a class of 'in-viewport", when we exit the section remove the class'
inView('.section')
    .on('enter', section => section.classList.add('in-viewport'))
    .on('exit', section => {
        section.classList.remove('in-viewport');
    });
// class is added after viewport is scrolled for 20%
inView.threshold(0.2);

// to add transition delay to artists and shapes inside each section
const sections = document.querySelectorAll('.section');
sections.forEach((section, index) => {
    const artists = section.querySelectorAll('.lineup li');
    const shapes = section.querySelectorAll('.shape');

    artists.forEach((artist, index) => {
        const delay = index * 100;
        artist.style.transitionDelay = delay + 'ms';
    });

    shapes.forEach((shape, index) => {
        const delay = (artists.length + index) * 100;
        shape.style.transitionDelay = delay + 'ms';
    });
});

const scrollLinks = document.querySelectorAll('.js-scroll');
scrollLinks.forEach(link => {
    link.addEventListener('click', (event) => {
        //it will block the default browser behaviour
        event.preventDefault();
        const href = link.getAttribute('href');
        document.querySelector(href).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

const hearts = document.querySelectorAll('.heart-icon');
const tooltips = document.querySelectorAll('.lineup h2 div');

function hideAllTooltips(tooltips) {
    tooltips.forEach(tooltip => tooltip.style.display = 'none');
}
hearts.forEach(heart => {
    heart.addEventListener('click', (e) => {
        hideAllTooltips(tooltips);
        const tooltip = e.target.parentNode.querySelector('h2 div');
        tooltip.style.display = 'block';

    });
});